import {WidgetDetails} from '@models/pages/user-defined-page/widget-details';
import {UserDefinedChartDetails} from '@models/pages/user-defined-page/user-defined-chart-details';

export class UserDefinedWidget {
  id: number = -1;
  machineId: number = -1;
  widgetDetails: WidgetDetails = new WidgetDetails();
  userDefinedChartDetails: UserDefinedChartDetails = new UserDefinedChartDetails();
}
